<template>
  <v-app class="pldc" style="height: 100%; max-width: 450px; border: 0;"
    :class="{on_desktop: $vuetify.breakpoint.smAndUp}"
  >
    <v-system-bar 
      absolute app window color="#004056"
      class="d-flex flex-column align-start justify-center"
      style="position: absolute; height: 55px; max-width: 450px"
    >
      <div class="white--text" style="font-size: 16px;">
        {{ me.user.name }}
      </div>
      <div class="white--text" style="font-size: 12px;">
        {{ me.business_name }}
      </div>
      <img src="@/assets/referra-pro-app-logo-305x104.png"
        style="position: absolute; right: 12px;"
        height="35px"
      >
    </v-system-bar>

    <v-main style="height: calc(100% - 115px);">
      <router-view />
    </v-main>
    <NavFooter />
  </v-app>
</template>

<script>
import NavFooter from './NavFooter'
import { mapGetters } from 'vuex'
import { requiresAuth } from '@/lib/auth'

export default {
  name: 'App',

  components: { NavFooter },
  
  data: () => ({
    keepAliveTimer: null,
  }),

  methods: {
    keepAlive() {
      this.$store.dispatch('auth/loadMe')
    }
  },

  computed: {
    ...mapGetters('auth', ['me', 'signedIn'])
  },

  watch: {
    signedIn(is_logged_in) {
      if (!is_logged_in) {
        this.$router.push({ name: 'login' })
      }
    }
  },

  created() {
    // check for life every 2 minutes
    this.keepAliveTimer = setInterval(this.keepAlive, 120 * 1000)
  },

  destroyed() {
    clearInterval(this.keepAliveTimer)
  },

  beforeRouteEnter: requiresAuth,
  beforeRouteUpdate: requiresAuth,
}
</script>

<style>
  html, body {
    height: 100%;
  }

  .v-application--wrap {
    min-height: 100vh !important;
    min-height: -webkit-fill-available !important;
  }
</style>